import { inject, Injectable } from '@angular/core';
import { ContractService } from '@/contract/services/contract.service';
import { ContractStore } from '@/contract/store/contract.store';

@Injectable({ providedIn: 'root' })
export class ContractFacade {
  private readonly contractService = inject(ContractService);

  private readonly contractStore = inject(ContractStore);

  public readonly selectedContract = this.contractStore.selectedContract;

  public readonly loading = this.contractStore.loading;

  public readonly error = this.contractStore.error.asReadonly();

  public readonly query = this.contractStore.query.asReadonly();

  /**
   * Asks the backend to send the user contract information and records whether the request succeeded.
   * The backend retrieves user and organization data from context.
   *
   * @returns {Promise<void>} Resolves once the request has been sent and its result stored.
   */
  public async requestContractInformation(): Promise<void> {
    const isResult = await this.contractService.requestContractInformation();
    this.contractStore.setContractInfoRequested(isResult);
  }
}
